import React from 'react';
import clsx from 'clsx';
import Tooltip from '@srm/ui/tooltip';
import { RATING_SCALE_LABEL, RATING_SCALE_RANGE } from '../utils/ratingScales';

interface IProps {
    /** Ключ шкалы из xml-настроек (simtum / pirsmr / pstz / tmcws / ''). */
    scaleKey: string;
    /** True если для критерия выбрана своя шкала (из settings.customScaleCrits). */
    isCustomScale: boolean;
    /** Hint для своей шкалы — из settings.ratingScaleHints[scaleKey]. */
    customScaleHint?: string;
}

/**
 * Бейдж шкалы оценки в левой sticky-колонке критерия.
 *
 * 3 варианта:
 * 1. customScaleHint: своя шкала с XML-описанием → tooltip из hint'а.
 * 2. Стандартная шкала с известным диапазоном → tooltip «Возможные оценки: …».
 * 3. Неизвестный fallback → просто бейдж без tooltip.
 */
export const ScaleBadge: React.FC<IProps> = ({ scaleKey, isCustomScale, customScaleHint }) => {
    const label = isCustomScale ? 'своя шкала' : (RATING_SCALE_LABEL[scaleKey] ?? 'шкала 0–5');
    const range = isCustomScale ? undefined : RATING_SCALE_RANGE[scaleKey];

    const badge = (
        <span className={clsx('ws-crit__badge', { 'ws-crit__badge--scale-custom': isCustomScale })}>{label}</span>
    );

    if (customScaleHint) {
        return (
            <Tooltip openDelay={100} background="black" position="bottom" label={customScaleHint}>
                {badge}
            </Tooltip>
        );
    }
    if (range) {
        return (
            <Tooltip openDelay={100} background="black" position="bottom" label={`Возможные оценки: ${range}`}>
                {badge}
            </Tooltip>
        );
    }
    return badge;
};
